import { render, staticRenderFns } from "./MenuInfScroll.vue?vue&type=template&id=4a378442&scoped=true&"
import script from "./MenuInfScroll.vue?vue&type=script&lang=js&"
export * from "./MenuInfScroll.vue?vue&type=script&lang=js&"
import style0 from "./MenuInfScroll.vue?vue&type=style&index=0&id=4a378442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a378442",
  null
  
)

export default component.exports